import { combineReducers } from "redux";

import { ticketsViewReducer } from "store/views/tickets/reducer";

import { agentsViewReducer } from "./agents";
import { invoicesViewReducer } from "./invoices/reducer";
import navigationViewReducer from "./navigation/reducer";
import reportsReducer from "./reports/reducer";
import { settingsViewReducer } from "./settings";
import subscriptionReducer from "./subscription/reducer";
import { teamsViewReducer } from "./teams";
import { welcomeTutorialViewReducer } from "./welcome-tutorial/reducer";

const viewsReducer = combineReducers({
  welcomeTutorial: welcomeTutorialViewReducer,
  agents: agentsViewReducer,
  invoices: invoicesViewReducer,
  navigation: navigationViewReducer,
  settings: settingsViewReducer,
  teams: teamsViewReducer,
  tickets: ticketsViewReducer,
  reports: reportsReducer,
  subscription: subscriptionReducer,
});

export type ViewsState = ReturnType<typeof viewsReducer>;

export default viewsReducer;
